import Paper from '@material-ui/core/Paper';
import React from 'react';
import styled from 'styled-components';
import ProjectProceduresHeader from './ProjectProceduresHeader';
import ProjectProceduresListItem from './ProjectProceduresListItem';
import ProjectsContext from './ProjectsContext';
import ProceduresManualTable from '../proceduresManual/ProceduresManualTable';
import CircluarProgress from '@material-ui/core/CircularProgress';
import CircularProgress from '@material-ui/core/CircularProgress';

const Container = styled.div`
    min-height: 100px;
    padding:20px;
`;

const TitleContainer = styled.div`
    display:flex;
    height:56px;
    align-items:center;
    padding-left:10px;
`;

const Title = styled.div`
color: rgba(0, 0, 0, 0.87);
font-family: Roboto;
font-size: 20px;
font-weight: 500;
letter-spacing: 0.25px;
line-height: 24px;
text-align: left;
`;

const EmptyDiv = styled.div`
height:60px;
`;

const CircluarProgressContainer = styled.div`
    width:100%;
    display:flex;
    align-items:center;
    height:200px;
    justify-content:center;
`;

const ProjectProcedures = props=> 
    <ProjectsContext.Consumer>
    {context => 
        <>
        {!context.procedureManual.fetchingProcedureManual && context.reduxStore.selectedProjectOrGbu && context.reduxStore.selectedFunction &&

        <Paper >
            <Container>
                <>
                <TitleContainer>
                    <Title>{`${context.reduxStore.selectedProjectOrGbu.name} ${context.reduxStore.selectedFunction.name} Procedure Manual`}</Title>
                </TitleContainer>
                   { context.procedureManual.procedures.length > 0 ? 
                        <ProceduresManualTable useTableWrapperStyles={false} procedures={context.procedureManual.procedures}/> :
                        (<EmptyDiv>
                            No procedures have been added
                        </EmptyDiv>)
                    } 
                </>    
                 

            </Container>
        </Paper>
                        }
        {context.procedureManual.fetchingProcedureManual &&
                    <CircluarProgressContainer><CircularProgress/></CircluarProgressContainer>
        }
        </>
    }
    </ProjectsContext.Consumer>

export default ProjectProcedures;

